var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookPlatform = function SvgFacebookPlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.998 50.1837C99.998 22.4682 77.6124 0 49.999 0C22.3855 0 0 22.4682 0 50.1837C0 73.7178 16.1437 93.4661 37.9212 98.8899V65.5198H27.6114V50.1837H37.9212V43.5755C37.9212 26.495 45.6231 18.578 62.3308 18.578C65.4987 18.578 70.9646 19.2023 73.2005 19.8246V33.7254C72.0206 33.601 69.9706 33.5388 67.4247 33.5388C59.2268 33.5388 56.0589 36.6562 56.0589 44.7598V50.1837H72.3905L69.5846 65.5198H56.0589V100C80.8164 96.999 100 75.8416 100 50.1837H99.998Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookPlatform);
export default ForwardRef;